import { UserDto, UserPageDto } from "../../../types/user/user-dto";
import { convertUserDtoToUser } from "../../../utils/converter/user/user-converter";
import { UserState } from "../../type/user-state";

interface Action {
  type: string;
  payload: {
    userPageDto: UserPageDto;
  };
}

export const setUserPageDispatch = (state: UserState, action: Action) => {
  const { userPageDto } = action.payload;
  state.userPage = {
    contents: userPageDto.contents.map((userDto: UserDto) => {
      return convertUserDtoToUser(userDto);
    }),
    first: userPageDto.first,
    last: userPageDto.last,
    page: userPageDto.page,
    totalPages: userPageDto.totalPages,
    totalElements: userPageDto.totalElements,
  };
};
